import { render, staticRenderFns } from "./ShiftsHeader.vue?vue&type=template&id=70301e98&lang=pug"
import script from "./ShiftsHeader.vue?vue&type=script&lang=js"
export * from "./ShiftsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports